import React from 'react';
import Tooltip from '../../components/Tooltip';
import { IconButton } from '../../components';
import { Link } from 'react-router-dom';
import classNames from '../../utility/classNames';
import { HiOutlineLockClosed } from 'react-icons/hi2';
import { isValue } from '../../utility/isValue';
import { formatLargeNumber } from '../../utility/formatNumbers';
import CriteriaPopupForm from './CriteriaPopupForm';
import InvestmentMetrics from '../../components/InvestmentMetrics';

export default function AnalysisSection({
  metricsData,
  header = '',
  description = '',
  data,
  actionLink,
  completed,
  prevCompleted,
  middle = false,
  first = false,
  metricsFormSchema,
  metricsEvalSchema,
}) {
  return (
    <div
      className={classNames(
        'flex flex-col justify-between gap-5 p-5',
        middle &&
          'border-b border-t md:border-b-0 md:border-t-0 md:border-l md:border-r border-neutral-50'
      )}
    >
      <div className="flex justify-between w-full items-center gap-2">
        <h3 className="font-md font-medium text-neutral-700 flex gap-1 items-center">
          {header}
          {description && (
            <span className="mt-[2px]">
              <Tooltip type="info" text={description} />
            </span>
          )}
        </h3>
        {!prevCompleted && !first && (
          <HiOutlineLockClosed className="text-neutral-700 text-2xl" />
        )}
      </div>
      <div className="grid grid-cols-2 min-h-[115px]">
        <div className="flex flex-col gap-4">
          {Array.isArray(metricsData) &&
            metricsData.map((metric) => {
              let title = metric.title;
              let value = metric.value;

              //special case to change title used for cash in / cash out
              if (Array.isArray(title)) {
                if (!isValue(value) || value >= 0) {
                  title = title[1];
                } else {
                  title = title[0];
                }
                if (typeof value === 'number') {
                  value = Math.abs(value);
                }
              }

              const formattedValue =
                typeof value === 'number'
                  ? `${metric.unit}${formatLargeNumber(value)}`.replace(
                      '$-',
                      '-$'
                    )
                  : '-';

              return (
                <div key={title} className="flex flex-col">
                  <span className="text-base text-neutral-500">{title}</span>
                  <span className="font-medium text-lg text-primary">
                    {formattedValue}
                  </span>
                </div>
              );
            })}
        </div>
        <div>
          {metricsFormSchema && metricsEvalSchema && (
            <div className="rounded-md bg-[#EFF8F3] w-full h-full p-5 relative flex flex-col justify-between gap-4 items-start">
              <CriteriaPopupForm schema={metricsFormSchema} />

              <InvestmentMetrics
                schema={metricsEvalSchema}
                data={data}
                type="overview"
                disabled={!completed}
              />
            </div>
          )}
        </div>
      </div>
      <div className="w-full flex justify-center items-center">
        <Link to={`../${actionLink}`} className="w-full">
          <IconButton
            text={completed ? 'View Report' : 'Start Worksheet'}
            disabled={!prevCompleted && !first}
            classes="min-w-full"
          />
        </Link>
      </div>
    </div>
  );
}
